import { Component, ChangeDetectionStrategy } from "@angular/core";

/**
 * This component serves as a dummy import for the app-routing.module.ts in production mode
 * to prevent the production bundle from being cluttered with unnecessary dev resources.
 */
@Component({
  selector: "component-overview",
  imports: [],
  templateUrl: "./dummy.html",
  styleUrls: ["./dummy.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class ComponentOverview {}
